import { matrixMinMaxZ } from 'ml-spectra-processing/matrix';
import { getFactorNumber } from "./getFactorNumber.js";
export function getBestFactorMatrix(matrix, options = {}) {
    const { maxValue, factor, minMax } = options;
    if (factor !== undefined) {
        return factor;
    }
    // is there non integer number ?
    let isOnlyInteger = true;
    for (const row of matrix) {
        for (const y of row) {
            if (Math.round(y) !== y) {
                isOnlyInteger = false;
                break;
            }
        }
    }
    if (isOnlyInteger) {
        return 1;
    }
    // we need to rescale the values
    // need to find the max and min values
    const extremeValues = minMax || matrixMinMaxZ(matrix);
    return getFactorNumber(extremeValues, maxValue);
}
//# sourceMappingURL=getBestFactorMatrix.js.map